import React from 'react';
import Modal from '../Modal/Modal';
import './AutoLogoutWarning.css';

const AutoLogoutWarning = ({ show, remainingTime, onStayLoggedIn, onLogout }) => {
  if (!show) return null;

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Prevent modal from closing - empty function prevents closing
  const preventClose = () => {
    // Do nothing - modal cannot be closed by clicking overlay or X button
  };

  return (
    <Modal 
      show={show} 
      title="" 
      setShowModal={preventClose}
    >
      <div className="auto-logout-warning">
        <div className="warning-header">
          <div className="warning-icon-wrapper">
            <div className="warning-icon">⚠️</div>
          </div>
          <h3 className="warning-title">Session Timeout Warning</h3>
        </div>
        <div className="warning-content">
          <p className="warning-message">
            Your session will expire due to inactivity in <span className="countdown-timer">{formatTime(remainingTime)}</span>
          </p>
          <p className="warning-submessage">
            Click "Stay Logged In" to continue your session, or you will be automatically logged out.
          </p>
        </div>
        <div className="warning-actions">
          <button className="stay-logged-in-btn" onClick={onStayLoggedIn}>
            Stay Logged In
          </button>
          <button className="logout-now-btn" onClick={onLogout}>
            Logout Now
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AutoLogoutWarning;

